export default __webpack_public_path__ + "static/media/birth-plan-02.3eb12927.png";